import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './App.css'; // CSS-Datei für Styling

import nadelIcon from './assets/icon_a.png';
import vereinsLogo from './assets/logo_black.png';

// Custom Icon für Marker
const customIcon = new L.Icon({
  iconUrl: nadelIcon,
  iconSize: [16, 16],
  iconAnchor: [8, 32],
  popupAnchor: [0, -32]
});

function App() {
  return (
    <div>
      {/* Header Leiste */}
      <header className="header">
        <div className="header-left">
          <img src={vereinsLogo} alt="Vereinslogo" className="logo" />
          <h1 className="title">Stickaround</h1>
        </div>
        <nav className="header-right">
          <a href="#leaderboard">Leaderboard</a>
          <a href="#report">Report Sticker</a>
        </nav>
      </header>

      {/* Karte */}
      <MapContainer center={[51.505, -0.09]} zoom={2} style={{ height: "90vh", width: "100%" }}>
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <Marker position={[51.505, -0.09]} icon={customIcon}>
          <Popup>
            Hier könnte ein Sticker-Standort sein.
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
}

export default App;